import { motion } from "framer-motion";
import { FileCode, ShieldAlert, ShieldQuestion, ShieldCheck } from "lucide-react";

function Stat({ label, value, color, icon: Icon, testid, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="border border-border bg-surface p-5 flex flex-col justify-between min-h-[120px]"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</span>
        <Icon className="w-4 h-4" style={{ color }} />
      </div>
      <span className="font-display font-bold text-4xl mt-3" style={{ color }}>{value}</span>
    </motion.div>
  );
}

export function DashboardStats({ result }) {
  const s = result.summary || {};
  const highCount = (s.critical || 0) + (s.high || 0);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="dashboard-stats">
      <Stat label="Files Scanned" value={result.files_scanned} color="#FAFAFA" icon={FileCode} testid="stat-files" delay={0.05} />
      <Stat label="High / Critical" value={highCount} color="#FF0055" icon={ShieldAlert} testid="stat-high" delay={0.1} />
      <Stat label="Medium" value={s.medium || 0} color="#FFD600" icon={ShieldQuestion} testid="stat-medium" delay={0.15} />
      <Stat label="Low" value={s.low || 0} color="#00E5FF" icon={ShieldCheck} testid="stat-low" delay={0.2} />
    </div>
  );
}
